import { render } from "./CreateEditCategoryModal.vue?vue&type=template&id=6a0783ff&scoped=true"
import script from "./CreateEditCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateEditCategoryModal.vue?vue&type=script&lang=js"

import "./CreateEditCategoryModal.vue?vue&type=style&index=0&id=6a0783ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0783ff"]])

export default __exports__